import { useDispatch, useSelector } from "react-redux";
import {
  ApplicationErrorActions,
  ApplicationErrorType,
} from "../redux/features/applicationErrorSlice";
import { RootState } from "../redux/store";

export const useApplicationError = () => {
  const dispatch = useDispatch();

  const applicationError = useSelector(
    (state: RootState) => state.applicationError
  );

  const showApplicationError = (errors: ApplicationErrorType) => {
    dispatch(ApplicationErrorActions.setErrors(errors));
  };

  const hideApplicationError = () => {
    dispatch(ApplicationErrorActions.clearErrors());
  };

  return {
    error: applicationError.error,
    showApplicationError,
    hideApplicationError,
  } as const;
};
